import { render } from "./ServiceCategoriesAccordion.vue?vue&type=template&id=e11c9b20"
import script from "./ServiceCategoriesAccordion.vue?vue&type=script&lang=js"
export * from "./ServiceCategoriesAccordion.vue?vue&type=script&lang=js"

import "./ServiceCategoriesAccordion.vue?vue&type=style&index=0&id=e11c9b20&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__